var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrag = function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drag",
    clipPath: "url(#clip0_15133_17912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.625 12.001C9.625 12.208 9.793 12.376 10 12.374C10.207 12.374 10.375 12.206 10.375 11.999C10.375 11.792 10.207 11.624 10 11.624C9.793 11.625 9.625 11.793 9.625 12.001Z",
    fill: "#8E8E93",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.625 8.001C9.625 8.208 9.793 8.376 10 8.374C10.207 8.374 10.375 8.206 10.375 7.999C10.375 7.792 10.207 7.624 10 7.624C9.793 7.625 9.625 7.793 9.625 8.001Z",
    fill: "#8E8E93",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.625 16.001C9.625 16.208 9.793 16.376 10 16.374C10.207 16.374 10.375 16.206 10.375 15.999C10.375 15.792 10.207 15.624 10 15.624C9.793 15.625 9.625 15.793 9.625 16.001Z",
    fill: "#8E8E93",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.625 12.001C13.625 12.208 13.793 12.376 14 12.374C14.207 12.374 14.375 12.206 14.375 11.999C14.375 11.792 14.207 11.624 14 11.624C13.793 11.625 13.625 11.793 13.625 12.001Z",
    fill: "#8E8E93",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.625 8.001C13.625 8.208 13.793 8.376 14 8.374C14.207 8.374 14.375 8.206 14.375 7.999C14.375 7.792 14.207 7.624 14 7.624C13.793 7.625 13.625 7.793 13.625 8.001Z",
    fill: "#8E8E93",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.625 16.001C13.625 16.208 13.793 16.376 14 16.374C14.207 16.374 14.375 16.206 14.375 15.999C14.375 15.792 14.207 15.624 14 15.624C13.793 15.625 13.625 15.793 13.625 16.001Z",
    fill: "#8E8E93",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15133_17912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgDrag as ReactComponent };
export default __webpack_public_path__ + "drag.svg";